var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#565656"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.084 17.5L22.7505 13.1566H18.5829V10.338C18.5829 9.14969 19.1651 7.99141 21.0316 7.99141H22.9263V4.29344C22.9263 4.29344 21.207 4 19.563 4C16.1309 4 13.8874 6.08031 13.8874 9.84625V13.1566H10.0723V17.5H13.8874V28H18.5829V17.5H22.084Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.46c58f968a5635b8e5b5fcbcf9ca5d38.svg";
export { ForwardRef as ReactComponent };